import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { Trash, CircleSlash2, AlertTriangle } from "lucide-react";

const icons = {
  trash: Trash,
  cancel: CircleSlash2,
  warning: AlertTriangle,
};

const SimpleMessageDialog = ({ open, onClose, title, message, icon }) => {
  const IconComponent = icons[icon] || null;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title || "Confirmación"}</DialogTitle>
      <DialogContent>
        {IconComponent && (
          <div className="flex justify-center mb-2">
            <IconComponent size={52} color="#FFA500" strokeWidth={2.25} />
          </div>
        )}
        <Typography>{message || "¿Estás seguro de realizar esta acción?"}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center', // Centra los botones
          paddingBottom: 2, // Espaciado inferior
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{
            marginLeft: 2, // Espaciado entre botones
            width: 'auto',
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SimpleMessageDialog;
